import { render } from "./header.vue?vue&type=template&id=5e8976ee&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=5e8976ee&scoped=true&lang=scss"
import "./header.vue?vue&type=style&index=1&id=5e8976ee&lang=scss"

import exportComponent from "D:\\workarea\\example\\景区旅游\\PC\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8976ee"]])

export default __exports__